import type { UseFormReturn } from "react-hook-form"

import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"

import { ChoiceField } from "@/components/forms/ChoiceField"
import { RequirementDetailsSection } from "./RequirementDetailsSection"
import { LicenseLogo } from "@/components/common/LicenseLogo"

type CostRecoveryProps = {
  form: UseFormReturn<LicenseData>
}

export const CostRecovery = ({ form }: CostRecoveryProps) => {
  const strings = useStrings()
  const requiresCostRecovery = form.watch("costRecovery") === "yes"

  return (
    <RequirementDetailsSection
      form={form}
      beforeFields={
        <ChoiceField
          form={form}
          name="costRecovery"
          label={strings.title.costRecoveryPrompt}
          description={strings.question.costRecoveryPrompt}
          behaviour="radio"
          options={[
            {
              title: strings.option.yes,
              description: (strings.affirmation.costRecovery as string[])[0],
              value: "yes",
              icon: <LicenseLogo logo="cost-recovery" />
            },
            {
              title: strings.option.no,
              description: (strings.affirmation.costRecovery as string[])[1],
              value: "no",
            }
          ]}
        />
      }
      fields={[
        ...(requiresCostRecovery
          ? [
              {
                kind: "text" as const,
                name: "costRecoveryContactEmail",
                label: strings.title.costRecoveryContactEmail,
                description: strings.question.costRecoveryContactEmail,
                inputProps: { type: "email" }
              },
              {
                kind: "text" as const,
                name: "costRecoveryContactUrl",
                label: strings.title.costRecoveryContactUrl,
                description: strings.question.costRecoveryContactUrl,
                inputProps: { type: "url" }
              },
              {
                kind: "textarea" as const,
                name: "costRecoveryDetails",
                label: strings.title.costRecoveryDetails,
                description: strings.question.costRecoveryDetails,
                textareaProps: { rows: 5 }
              }
            ]
          : [])
      ]}
    />
  )
}
